import styles from './Tables.module.scss'
import { FC } from 'react'
import { TtableForRowRenderData } from '../../types'
import { NumericFormat } from 'react-number-format'

type TTableProps = {
    renderDataForTable: TtableForRowRenderData[]
}

export const Table: FC<TTableProps> = ({ renderDataForTable }) => {

    return (
        <div className={styles.tableContainer}>
            <table className={`${styles.table} `}>
                <thead>
                    <tr>
                        <th></th>
                        <th className={styles.weight} colSpan={4}>Monthly change</th>
                        <th className={`${styles.total} ${styles.weight}`} colSpan={6}>Total</th>
                        <th className={`${styles.difference} ${styles.weight}`} colSpan={3}>Difference</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Month</td>
                        <td colSpan={2} className={styles.weight}>New customers</td>
                        <td colSpan={2} className={styles.weight}>Lost customers</td>
                        <td className={`${styles.total} ${styles.weight}`} colSpan={2}>Paying customers</td>
                        <td className={`${styles.total} ${styles.weight}`} colSpan={2}>MRR</td>
                        <td className={`${styles.total} ${styles.weight}`} colSpan={2}>Revenue generated</td>
                        <td className={`${styles.difference} ${styles.weight}`} > Total investment</td>
                        <td className={`${styles.difference} ${styles.weight}`} >Total profit</td>
                        <td className={`${styles.difference} ${styles.weight}`} >Total ROI</td>
                    </tr>
                    <tr>
                        <td className={styles.beforeAfter}></td>
                        <td className={styles.beforeAfter}>Before</td>
                        <td className={styles.beforeAfter}>After</td>
                        <td className={styles.beforeAfter}>Before</td>
                        <td className={styles.beforeAfter}>After</td>
                        <td className={styles.total}>
                            <span className={styles.beforeAfter}>
                                Before
                            </span>
                        </td>
                        <td className={styles.total}>
                            <span className={styles.beforeAfter}>
                                After
                            </span>
                        </td>
                        <td className={styles.total}>
                            <span className={styles.beforeAfter}>
                                Before
                            </span>
                        </td>
                        <td className={styles.total}>
                            <span className={styles.beforeAfter}>
                                After
                            </span>
                        </td>
                        <td className={styles.total}>
                            <span className={styles.beforeAfter}>
                                Before
                            </span>
                        </td>
                        <td className={styles.total}> <span className={styles.beforeAfter}>
                            After
                        </span>
                        </td>

                        <td className={`${styles.difference} ${styles.weight}`} colSpan={3} ></td>
                    </tr>
                    {renderDataForTable.map((row, i) => (
                        <tr key={i}>
                            <td>{i}</td>
                            <td>{row.newCustomers.before}</td>
                            <td>{row.newCustomers.after}</td>
                            <td>{row.lostCustomers.before}</td>
                            <td>{row.lostCustomers.after}</td>
                            <td className={styles.total}>{row.payingCustomers.before}</td>
                            <td className={styles.total}>{row.payingCustomers.after}</td>
                            < NumericFormat value={row.mmr.before} displayType={'text'} thousandSeparator={true} prefix={'$'}
                                renderText={(value) => <td className={styles.total}>{value}</td>} />
                            < NumericFormat value={row.mmr.after} displayType={'text'} thousandSeparator={true} prefix={'$'}
                                renderText={(value) => <td className={styles.total}>{value}</td>} />
                            < NumericFormat value={row.revenueGenerated.before} displayType={'text'} thousandSeparator={true} prefix={'$'}
                                renderText={(value) => <td className={styles.total}>{value}</td>} />
                            < NumericFormat value={row.revenueGenerated.after} displayType={'text'} thousandSeparator={true} prefix={'$'}
                                renderText={(value) => <td className={styles.total}>{value}</td>} />
                            < NumericFormat value={row.totalInvestment} displayType={'text'} thousandSeparator={true} prefix={'$'}
                                renderText={(value) => <td className={`${styles.difference} ${styles.weight}`} >{value}</td>} />
                            < NumericFormat value={row.totalProfit} displayType={'text'} thousandSeparator={true} prefix={'$'}
                                renderText={(value) => <td className={`${styles.difference} ${styles.weight}`} >{value}</td>} />
                            < NumericFormat value={row.totalROI} allowNegative={false} displayType={'text'} suffix={'%'} prefix={row.totalROI >= 0 ? '' : '-'}
                                renderText={(value) => <td className={`${styles.difference} ${styles.weight}`} >{value}</td>} />
                        </tr>
                    ))}
                </tbody>
            </table>

        </div>
    )
}
